<template>
  <div>
    <v-row
        v-for="message in messages" v-bind:key="message.uuid"
        no-gutters style="flex-wrap: nowrap;"
        class="messages-list-message pb-2"
        :class="currentUsername == message.sender_username ? 'flex-row-reverse' : 'flex-row'"
    >
      <v-col
          v-if="!$vuetify.breakpoint.mobile"
          cols="1"
          class="flex-grow-0 flex-shrink-0 text-center"
      >
        <v-avatar color="teal" size="36">
          <span class="white--text headline">{{ message.sender_username[0].toUpperCase() }}</span>
        </v-avatar>
      </v-col>
      <v-col
          cols="1"
          style="min-width: 100px; max-width: 100%;"
          class="flex-grow-1 flex-shrink-0"
      >
        <v-card
            class="pa-2 d-inline-block"
            elevation-1
        >
          <div class="overline">{{ message.sender_full_name }}</div>
          <div class="messages-list-message__body" v-html="message.body">
          </div>
          <div class="caption grey--text font-weight-light">{{ message.timestamp|formatDate }}</div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import moment from 'moment'

export default {
  components: {},
  name: 'MessagesList',
  props: {
    messages: Array
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(
        {
          currentUsername: 'auth/username'
        }
    )
  },
  filters: {
    formatFromNow(date) {
      return moment(date).fromNow()
    },
    formatlll(date) {
      return moment(date).format('lll')
    },
    formatDate(date) {
      if (moment().diff(date, 'days') > 1) {
        return moment(date).format('lll')
      } else {
        return moment(date).fromNow()
      }
    }
  },
  methods: {},
  mounted() {
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.messages-list {
  &-message {
    &__body {
      text-align: left;
    }

    &.flex-row-reverse {
      text-align: right;
    }
  }
}
</style>